const _jsxFileName = '';
import React, { useRef, useEffect, useState } from 'react';
import { ArrowUpRight } from 'lucide-react';

const FeaturedCollection = ({ onNavigate }) => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return React.createElement(
    'section',
    {
      ref: sectionRef,
      className: 'py-24 bg-stone-50 relative overflow-hidden',
      __self: this,
      __source: { fileName: _jsxFileName, lineNumber: 24 },
    },
    /* Background Texture */
    React.createElement('div', {
      className: 'absolute inset-0 bg-noise opacity-30 pointer-events-none',
      __self: this,
      __source: { fileName: _jsxFileName, lineNumber: 26 },
    }),

    /* Decorative Line */
    React.createElement('div', {
      className: 'absolute top-0 left-1/2 -translate-x-1/2 w-[1px] h-24 bg-gold-200',
      __self: this,
      __source: { fileName: _jsxFileName, lineNumber: 29 },
    }),

    React.createElement(
      'div',
      {
        className: 'max-w-7xl mx-auto px-6 relative z-10',
        __self: this,
        __source: { fileName: _jsxFileName, lineNumber: 31 },
      },
      React.createElement(
        'div',
        {
          className: 'flex flex-col lg:flex-row items-center gap-16',
          __self: this,
          __source: { fileName: _jsxFileName, lineNumber: 32 },
        },

        /* Image Side */
        React.createElement(
          'div',
          {
            className: `lg:w-3/5 w-full relative group transition-all duration-1000 transform ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-20 opacity-0'}`,
            __self: this,
            __source: { fileName: _jsxFileName, lineNumber: 35 },
          },
          React.createElement('div', {
            className:
              'absolute -inset-4 border border-gold-200 translate-x-4 translate-y-4 group-hover:translate-x-2 group-hover:translate-y-2 transition-transform duration-500',
            __self: this,
            __source: { fileName: _jsxFileName, lineNumber: 36 },
          }),
          React.createElement(
            'div',
            {
              className: 'relative overflow-hidden aspect-[4/3] shadow-xl',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 37 },
            },
            React.createElement('img', {
              src: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?q=80&w=2070&auto=format&fit=crop',
              alt: 'Signature Jewelry',
              className:
                'w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 38 },
            }),
            React.createElement(
              'div',
              {
                className: 'absolute top-6 left-6 bg-white/90 backdrop-blur px-4 py-2 shadow-sm',
                __self: this,
                __source: { fileName: _jsxFileName, lineNumber: 43 },
              },
              React.createElement(
                'span',
                {
                  className: 'text-[10px] tracking-[0.2em] uppercase text-stone-900 font-bold',
                  __self: this,
                  __source: { fileName: _jsxFileName, lineNumber: 44 },
                },
                'Signature Pieces'
              )
            )
          )
        ),

        /* Text Side */
        React.createElement(
          'div',
          {
            className: `lg:w-2/5 w-full text-center lg:text-left transition-all duration-1000 delay-300 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'}`,
            __self: this,
            __source: { fileName: _jsxFileName, lineNumber: 50 },
          },
          React.createElement(
            'span',
            {
              className: 'text-gold-600 text-xs tracking-[0.25em] uppercase mb-4 block',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 51 },
            },
            'Refined Elegance'
          ),
          React.createElement(
            'h2',
            {
              className: 'font-serif text-4xl md:text-5xl text-stone-900 mb-6 leading-tight',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 52 },
            },
            'Jewelry That Holds ',
            React.createElement('br', {
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 53 },
            }),
            React.createElement(
              'span',
              {
                className:
                  'text-transparent bg-clip-text bg-gradient-to-r from-gold-500 to-gold-700',
                __self: this,
                __source: { fileName: _jsxFileName, lineNumber: 54 },
              },
              'Attention'
            )
          ),
          React.createElement(
            'p',
            {
              className: 'text-stone-600 font-light mb-8 leading-relaxed',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 56 },
            },
            'Explore standout pieces with clean product pages, wishlist functionality, and bag actions built in. Each piece tells a story of craftsmanship and heritage.'
          ),

          React.createElement(
            'div',
            {
              className: 'flex flex-col sm:flex-row gap-4 justify-center lg:justify-start',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 60 },
            },
            React.createElement(
              'button',
              {
                onClick: () => onNavigate('collections'),
                className:
                  'bg-stone-900 text-white px-8 py-3 text-xs tracking-[0.2em] uppercase hover:bg-gold-600 transition-colors shadow-lg shadow-stone-200',
                __self: this,
                __source: { fileName: _jsxFileName, lineNumber: 61 },
              },
              'Shop Jewelry'
            ),
            React.createElement(
              'button',
              {
                onClick: () => onNavigate('shop'),
                className:
                  'border border-stone-300 text-stone-600 px-8 py-3 text-xs tracking-[0.2em] uppercase hover:border-gold-500 hover:text-gold-600 transition-colors flex items-center gap-2 justify-center',
                __self: this,
                __source: { fileName: _jsxFileName, lineNumber: 67 },
              },
              'View All ',
              React.createElement(ArrowUpRight, {
                size: 14,
                __self: this,
                __source: { fileName: _jsxFileName, lineNumber: 71 },
              })
            )
          ),

          /* Features Mini-Grid */
          React.createElement(
            'div',
            {
              className: 'mt-12 grid grid-cols-3 gap-4 border-t border-stone-200 pt-8',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 76 },
            },
            ['Curated', 'Authentic', 'Seamless'].map((item) =>
              React.createElement(
                'div',
                {
                  key: item,
                  className: 'text-center lg:text-left',
                  __self: this,
                  __source: { fileName: _jsxFileName, lineNumber: 78 },
                },
                React.createElement(
                  'h4',
                  {
                    className: 'text-gold-700 text-xs uppercase tracking-widest mb-1',
                    __self: this,
                    __source: { fileName: _jsxFileName, lineNumber: 79 },
                  },
                  item
                ),
                React.createElement(
                  'span',
                  {
                    className: 'text-[10px] text-stone-500',
                    __self: this,
                    __source: { fileName: _jsxFileName, lineNumber: 80 },
                  },
                  'Premium Standard'
                )
              )
            )
          )
        )
      )
    )
  );
};

export default FeaturedCollection;
